import { render } from "./autoPrescription.vue?vue&type=template&id=42800524&scoped=true"
import script from "./autoPrescription.vue?vue&type=script&lang=js"
export * from "./autoPrescription.vue?vue&type=script&lang=js"

import "./autoPrescription.vue?vue&type=style&index=0&id=42800524&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42800524"]])

export default __exports__